<template>
  <v-app>

    <Navbar/>

    <v-main>
      <template>
        <v-progress-linear indeterminate color="yellow darken-2" :active="GetLoading"></v-progress-linear>  
      </template>
      <router-view></router-view>
    </v-main>

    <template>
      <div class="text-center">
        <v-snackbar v-model="GetMsg.snackbar" :timeout="GetMsg.timeout"  :color="GetMsg.color">
          {{ GetMsg.text }}
          <template v-slot:action="{ attrs }">
            <v-btn color="#ffffff"  text  v-bind="attrs"  @click="GetMsg.snackbar = false" >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </div>
    </template>

  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar";
export default {
  name: "App",
  components: { Navbar },
  computed : {
    GetMsg:function(){
      return this.$store.getters.getMsg
    },
    GetLoading:function(){
      return this.$store.getters.getLoading
    }
  }
};
</script>


